import { gsap, ScrollToPlugin } from "gsap/all";

export default () => {
  gsap.registerPlugin(ScrollToPlugin);

  //------------------------------------------------------//
  // 📝 Form labels
  //------------------------------------------------------//
  document
    .querySelectorAll(".gfield input, .gfield textarea")
    .forEach(function (input) {
      // Check if value
      if (input.value) {
        if (
          input.previousElementSibling &&
          input.previousElementSibling.tagName == "LABEL"
        ) {
          input.previousElementSibling.classList.add("selectedInput");
        }
        input
          .closest(".gfield")
          .querySelector(".gfield_label")
          .classList.add("selectedInput");
      }
      // On focus
      input.addEventListener("focus", (event) => {
        if (
          input.previousElementSibling &&
          input.previousElementSibling.tagName == "LABEL" &&
          !input.value
        ) {
          input.previousElementSibling.classList.add("selectedInput");
        }
        input
          .closest(".gfield")
          .querySelector(".gfield_label")
          .classList.add("selectedInput");
      });
      // On focus loss
      input.addEventListener("blur", (event) => {
        if (
          input.previousElementSibling &&
          input.previousElementSibling.tagName == "LABEL" &&
          !input.value
        ) {
          input.previousElementSibling.classList.remove("selectedInput");
        }
        if (!input.value) {
          input
            .closest(".gfield")
            .querySelector(".gfield_label")
            .classList.remove("selectedInput");
        }
      });
    });
  // END 📝 Form labels -------------------------------------//

  //--------------------------------//
  // Validation 
  //--------------------------------//
  document.querySelectorAll('[aria-required="true"]').forEach(input => {
    const checkState = () => {
      const hasValue = input.value.trim().length > 0;
      input.classList.toggle('is-filled', hasValue);
      input.classList.toggle('is-empty', !hasValue);
    };

    // mark that user interacted, so you don’t show red borders from the start
    input.addEventListener('blur', () => {
      input.classList.add('user-interacted');
      checkState();
    });

    input.addEventListener('input', checkState);
    checkState(); // run once on load
  });

  // END Validation --------------//

  //--------------------------------//
  // scroll to form 
  //--------------------------------//
  const errorMessage = document.querySelector('.gform_submission_error');
  if (errorMessage) {
    gsap.to(window, { duration: 0.5, delay: 0.5, scrollTo: { y: errorMessage, offsetY: 100 } });
  }
  // END scroll to form --------------//
};
